import { TbUser, TbSettings, TbLogout } from 'react-icons/tb';

import { createLocale } from 'locales';

import type { NavigationBarLink } from 'components-new/navigation-bar/navigation-bar';
import type { AvatarMenuItemType } from 'components-new/navigation-bar/avatar-menu/avatar-menu-item';
import type { AvatarMenuViewType } from 'components-new/navigation-bar/avatar-menu/avatar-menu-view';

const globalLocalize = createLocale('global');

const getNewNavigationBarLinks = (
  selectedLink?: string,
): NavigationBarLink[] => {
  const navigationBar: NavigationBarLink[] = [
    {
      id: 'dashboard',
      isSelected: false,
      link: '/organisation/',
      title: globalLocalize('dashboard'),
    },
    {
      id: 'assignments',
      isSelected: false,
      link: '/organisation/planner/',
      title: globalLocalize('assignments'),
    },
    {
      id: 'invoices',
      isSelected: false,
      link: '/organisation/invoice/',
      title: globalLocalize('invoices'),
    },
    {
      id: 'settings',
      isSelected: false,
      link: '/organisation/settings/',
      title: globalLocalize('settings'),
    },
  ];

  if (selectedLink) {
    const selectedLinkIndex = navigationBar.findIndex(
      (link) => link.id === selectedLink,
    );

    navigationBar[selectedLinkIndex].isSelected = true;
  }

  return navigationBar;
};

export const getAccountMenuItems = (
  isFreelancer: boolean,
): AvatarMenuItemType[] => {
  return [
    ...(isFreelancer
      ? [
          {
            icon: TbUser,
            link: '/freelancer/profile/',
            name: globalLocalize('checkProfile'),
          },
          {
            icon: TbSettings,
            link: '/freelancer/settings/personal/',
            name: globalLocalize('accountSettings'),
          },
        ]
      : []),
    {
      icon: TbLogout,
      link: '/logout/',
      name: globalLocalize('logout'),
    },
  ];
};

export const accountMenuViews = [
  {
    link: '/freelance',
    name: globalLocalize('freelancer'),
    selected: false,
    type: 'freelancer',
  },
  {
    link: '/organisation',
    name: globalLocalize('organisation'),
    selected: false,
    type: 'organisation',
  },
  {
    link: '/staff',
    name: globalLocalize('staff'),
    selected: false,
    type: 'staff',
  },
] as AvatarMenuViewType[];

export const getAccountMenuViews = (
  isFreelancer: boolean,
  isOrganisationAdmin: boolean,
  isStaff: boolean,
  selected?: string,
): AvatarMenuViewType[] => {
  const allowedTypes: string[] = [];
  if (isFreelancer) allowedTypes.push('freelancer');
  if (isOrganisationAdmin) allowedTypes.push('organisation');
  if (isStaff) allowedTypes.push('staff');

  return accountMenuViews
    .filter(({ type }) => allowedTypes.includes(type))
    .map((view) => ({ ...view, selected: view.type === selected }));
};

export default getNewNavigationBarLinks;
